<template>
  <el-dialog
    :visible="visible"
    top="20%"
    class="confirm-dialog-2"
    append-to-body
    destroy-on-closes
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-on="$listeners"
  >
    <h2 v-if="title" class="header-dialog">{{ title }}</h2>
    <p class="content whitespace-pre-wrap" :class="[contentClass]">
      <slot name="content">
        {{ content }}
      </slot>
    </p>
    <slot name="action">
      <div class="flex flex-col justify-center items-center">
        <el-button class="confirm-dialog-2__btn submit-btn" :class="[btnClass]" @click="onAccept">{{
          acceptText
        }}</el-button>
        <el-button class="confirm-dialog-2__btn cancel-btn" @click="onCancel">{{ cancelText }}</el-button>
      </div>
    </slot>
  </el-dialog>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    visible: Boolean,
    content: {
      type: String,
      default: () => '',
    },
    contentClass: { type: String, default: () => '' },
    title: {
      type: String,
      default: () => '',
    },
    acceptText: {
      type: String,
      default: function () {
        return this.$t('common.label.yes')
      },
    },
    cancelText: {
      type: String,
      default: function () {
        return this.$t('common.action.close')
      },
    },
    btnClass: {
      type: String,
      default: '',
    },
  },

  methods: {
    onCancel() {
      this.$emit('close')
    },
    onAccept() {
      this.$emit('accept')
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/confirm-dialog-2.scss';
</style>
